module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp1_8003.b954258e.png";